import React from 'react';

import SwitchToggle from '@/components/ui/SwitchToggle/SwitchToggle';
import {AEM_DEVICE_SETTINGS_TYPES} from '@/consts/aem/aemDeviceSettingsTypes';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {twx} from '@/utils/tailwindUtils';

import DevicesSettingsSectionNew from '../../../DevicesSettingsSection/DevicesSettingsSectionNew';
import DeviceSettingsSwitchItem from '../../components/DeviceSettingLayout/DeviceSettingsSwitchItem';
import useDeviceSettingHolderGuard from '../../hooks/useDeviceSettingHolderGuard';
import {useDeviceLock} from './useDeviceLock';

const DeviceLock = ({className}) => {
    const isMobile = useIsMobileLayout();
    const {isDeviceLocked, onChange, currentValue, content} = useDeviceLock();
    const {shouldDisableInputs, onDisabledSaveClick} = useDeviceSettingHolderGuard(
        AEM_DEVICE_SETTINGS_TYPES.LOCK_UNLOCK
    );

    const {title} = content;

    return isMobile ? (
        <MobileDeviceLock
            onChange={onChange}
            title={title}
            isDeviceLocked={isDeviceLocked}
            className={className}
            icon={currentValue?.icon}
            subTitle={currentValue?.icon?.title}
            isDisabled={shouldDisableInputs}
            onDisabledClick={onDisabledSaveClick}
        />
    ) : (
        <DesktopDeviceLock
            onChange={onChange}
            title={title}
            isDeviceLocked={isDeviceLocked}
            className={className}
            isDisabled={shouldDisableInputs}
            onDisabledClick={onDisabledSaveClick}
        />
    );
};

const MobileDeviceLock = ({onChange, title, icon, subTitle, isDeviceLocked, isDisabled, onDisabledClick}) => {
    return (
        <DevicesSettingsSectionNew.Button
            title={title}
            icon={icon}
            as='div'
            subTitle={subTitle}
            hideArrow
            isLast
            isDisabled={isDisabled}
            onDisabledClick={onDisabledClick}
        >
            <SwitchToggle isActive={isDeviceLocked} onChange={onChange} isDisabled={isDisabled} />
        </DevicesSettingsSectionNew.Button>
    );
};

const DesktopDeviceLock = ({onChange, title, className, isDeviceLocked, isDisabled, onDisabledClick}) => (
    <DeviceSettingsSwitchItem
        title={title}
        isActive={isDeviceLocked}
        onChange={onChange}
        className={twx('justify-start p-0', className)}
        isDisabled={isDisabled}
        onDisabledClick={onDisabledClick}
    />
);

export default DeviceLock;
